import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("LocalizedKeyWidget", {
  title: "Localized Key",
  titleForContent(widget) {
    return widget.get("key");
  },
  attributes: {
    key: {
      title: "Key",
    },
    de: {
      title: "German translation",
    },
    en: {
      title: "English translation",
    },
  },
  properties: ["key", "de", "en"],
});
